<template>
    <section>
        <vx-card style="box-shadow:none;border: 1px dotted #ccc;overflow: auto;" class="my-6 h-screen">
            <section v-if="reports.length > 0">
                <div 
                    class="progress flex align-top mb-4 cursor-pointer"
                    v-for="(item, i) in reports"
                    :key="i"
                    @click.prevent="viewDetail(item)"
                >
                    <div class="line-wrapper px-5 flex justify-center items-center flex-col" style="width: 4    %;-webkit-box-pack: center;flex-basis: 0px;">
                        <div class="circle relative mb-auto" :class="item.class" style="width: 18px;height: 18px;border-radius: 50%;"></div>
                        <div class="line"></div>
                    </div>
                    <div class="w-full status-wrapper">
                        <vx-card>
                            <h5 class="mb-2"><strong>{{ item.name }}</strong></h5>
                            <p class="text-grey">
                                {{ getDate(item) }}
                            </p>
                        </vx-card>
                    </div>
                </div>
            </section>
            <section v-else>
                <p class="text-grey text-center">Belum ada laporan penyaluran</p>
            </section>
        </vx-card>
        <!-- Prop -->
        <vs-popup title="Detail Laporan Penyaluran Qurban" :active.sync="showDetailModal">
            <div>
                <header v-if="data.file != null && data.file != ''" class="mb-6 flex justify-center" style="overflow:auto;">
                    <img :src="getImage(data.file)" alt="" class="w-48 mx-auto" />
                </header>
                <h3 class="mb-4">{{data.name}}</h3>
                <div class="vx-row items-center">
                    <section class="vx-col w-1/2">
                        <strong class="block mb-2">Deskripsi</strong>
                        <div v-html="data.description"></div>
                    </section>
                    <section class="vx-col w-1/2">
                        <strong class="block mb-2">Waktu Pelaporan</strong>
                        <div>
                            {{getDate(data, true)}}
                        </div>
                    </section>
                </div>
            </div>
        </vs-popup>
        <!-- / -->
    </section>
</template>
<script>
export default {
    methods: {
        getImage(image) {
            if(image != null && image != '') {
                return process.env.VUE_APP_STORAGE + '/' + image;
            }

            return null;
        },
        viewDetail(item) {
            Object.assign(this.data, item);
            this.showDetailModal = true;
        },
        getDate(item, displayTime = false) {
            if(item.updated_at) {
                const arrDate = item.updated_at.split('.'),
                    arrDateAndTime = arrDate[0].split('T');
                let result = arrDateAndTime[0].split('-').reverse().join('-'),
                    time = arrDateAndTime[1].split('-').reverse().join('-');

                if(displayTime) {
                    result += ' ' +time;
                }

                if(arrDateAndTime.length && arrDateAndTime.length > 0) {
                    return result;
                }
            }

            return '-';
        }
    },
    data: () => ({
        showDetailModal: false,
        data: {
            name: null,
            updated_at: null,
            created_at: null,
            file: null,
            description: null,
            id: null
        }
    }),
    props: {
        reports: {
            type: Array,
            default: () => [
                {
                    name: 'Nam',
                    updated_at: null,
                    created_at: null,
                    file: null,
                    description: null,
                    id: null
                },
                {
                    name: 'Nam2',
                    updated_at: null,
                    created_at: null,
                    file: null,
                    description: null,
                    id: null
                }
            ]
        }
    },
    created() {
        this.reports.map((item, i) => {
            item.class = 'circle-inactive';
            if(i == (this.reports.length - 1)) {
                item.class = 'circle-active';
            }
        });
    }
}
</script>
<style>
	.line-wrapper .line {
		width: 5px;
		height: calc(100% - 9px);
		margin-bottom: -12px;
		background-image: linear-gradient(to bottom,var(--N100,#DBDEE2) 55%,rgba(255,255,255,0) 55%);
		background-position: left center;
		background-size: 1px 13px;
		background-repeat: repeat-y;	
	}
	.circle::before {
		width: 16px;
		position: absolute;
		height: 16px;
		border-radius: 50%;
		background-color: #fff5cc;
		transition: all 0.5s ease-out 0s;
		animation-name: grow;
		animation-duration: 1400ms;
		animation-timing-function: ease-out;
		animation-iteration-count: infinite;
		animation-fill-mode: none;
		animation-play-state: running;
		content: "";
	}
	.circle::after {
		border-radius: 50%;
		content: "";
		position: absolute;
		width: 13px;
		height: 13px;
		left: 1px;
		top: 1px;
	}
    .circle-active::after {
        background-color: var(--G500,#FFCB05);
    }
    .circle-inactive::after {
        background-color: var(--G500,#ddd);
    }
</style>